import copyCite2x from 'images/copyCite2x.jpg'
import copyCitehover2x from 'images/copyCitehover2x.jpg'
import mbicon2x from 'images/mbicon2x.jpg'
import up2x from 'images/up2x.jpg'
import cha2x from 'images/cha2x.jpg'
import gou2x from 'images/gou2x.jpg'
import Reload2x from 'images/Reload2x.jpg'
import Download2x from 'images/Download.svg'

const obj = {
  copyCite2x,
  copyCitehover2x,
  mbicon2x,
  up2x,
  cha2x,
  gou2x,
  Reload2x,
  Download2x
}

export const getIcon = function (name) {
  return obj[name]
}
